import { useTranslation } from "react-i18next";
import type { SchemaElement } from "../../../../api/restaurantSchema";
import { ELEMENT_SIZES, ELEMENT_STYLES } from "../../../../components/restaurant-schema/elementCatalog";
import { Field, Segmented } from "../modals/formControls";
import type { SchemaEditorActions } from "../useSchemaEditorActions";
import { InspectorCard } from "./InspectorCard";

/**
 * Инспекторът на избран обект — в стила на този за маса: размер (обектите
 * нямат места, от които да следва) и завъртане.
 */
const ObjectInspector = ({
  element,
  actions,
  onDuplicate,
  onClose,
}: {
  element: SchemaElement;
  actions: SchemaEditorActions;
  onDuplicate: () => void;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const style = ELEMENT_STYLES[element.kind];
  const kindLabel = t(style.labelKey);

  return (
    <InspectorCard
      badge={
        <span
          className={`flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-[10px] ${style.chipClass}`}
        >
          <style.Icon className="h-[18px] w-[18px]" />
        </span>
      }
      title={kindLabel}
      subtitle={t("restaurantSchema.inspector.objectSubtitle", {
        size: t(`restaurantSchema.sizes.${element.size}`),
      })}
      rotation={element.rotation}
      onRotate={(direction) => actions.rotateElement(element, direction)}
      onDuplicate={onDuplicate}
      onDelete={() => void actions.deleteElement(element)}
      onClose={onClose}
    >
      <Field label={t("restaurantSchema.inspector.size")}>
        <Segmented
          options={ELEMENT_SIZES.map((size) => ({
            value: size,
            label: t(`restaurantSchema.sizes.${size}`),
          }))}
          value={element.size}
          onChange={(size) => size !== element.size && actions.updateElement(element, { size })}
        />
      </Field>
    </InspectorCard>
  );
};

export default ObjectInspector;
